import { Immutable } from '@zervant/reactcomponents'

import * as DocumentNumberActions from '../actions/documentNumber'
import { InvoiceDocumentNumberType } from '../Interfaces/Draft/DraftInterface'
import { ReducerBuilder } from './ReducerBuilder'

export const INITIAL_STATE = {
  active: null,
  all: [],
  hasUserDefinedOne: true,
}

type StateType = {
  active: InvoiceDocumentNumberType
  all: InvoiceDocumentNumberType[]
  hasUserDefinedOne: boolean
}

type PayloadType = InvoiceDocumentNumberType | InvoiceDocumentNumberType[] | InvoiceDocumentNumberType['prefix']

function hasUserDefinedAtleastOneSequence(sequences: InvoiceDocumentNumberType[]) {
  return sequences.filter((sequence) => sequence.userDefined).length > 0
}

function addNewInvoiceNumberSequence(state: StateType, payload: InvoiceDocumentNumberType) {
  const newState = Immutable.copy(state)
  newState.active = payload
  newState.all = newState.all.concat(payload)
  newState.hasUserDefinedOne = hasUserDefinedAtleastOneSequence(newState.all)
  return newState
}

export function replaceInvoiceNumberSequences(state: StateType, payload: InvoiceDocumentNumberType[]) {
  return {
    active: payload.find((sequence) => sequence.active) || payload[0],
    all: payload,
    hasUserDefinedOne: hasUserDefinedAtleastOneSequence(payload),
  }
}

function activateInvoiceNumberSequence(state: StateType, payload: InvoiceDocumentNumberType['prefix']) {
  const newState = Immutable.copy(state)
  newState.active = newState.all.find((sequence) => sequence.prefix === payload)
  newState.all = newState.all.map((sequence) => {
    sequence.active = sequence.prefix === payload
    return sequence
  })
  return newState
}

const reducer = ReducerBuilder.create<StateType, PayloadType>(INITIAL_STATE)
  .mapAction(DocumentNumberActions.Type.CREATE_INVOICE_NUMBER_SEQUENCE, addNewInvoiceNumberSequence)
  .mapAction(DocumentNumberActions.Type.GET_INVOICE_NUMBER_SEQUENCES, replaceInvoiceNumberSequences)
  .mapAction(DocumentNumberActions.Type.ACTIVATE_INVOICE_NUMBER_SEQUENCE, activateInvoiceNumberSequence)
  .build()

export default reducer
